import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createAuthApi } from 'api/authApi'
import { AuthProvider } from 'context/authContext'
import { getAuthBaseUrl, getStripeClientKey } from 'utils/env'
import { ToastProvider } from 'context/toastContext'
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { FetchError } from 'utils/error'
import { ConfirmMessageProvider } from 'context/confirmModalContext'
import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { NavigationContainer } from 'containers/navigationContainer'

const authApi = createAuthApi(getAuthBaseUrl())
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (e: unknown): void => {
      const error = e as FetchError | undefined
      const UNAUTHORIZED = 401

      if (error?.res?.status === UNAUTHORIZED) {
        authApi.logout()
      }
    }
  })
})

const stripePromise = loadStripe(getStripeClientKey())

function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider authApi={authApi}>
          <ToastProvider>
            <ConfirmMessageProvider>
              <Elements stripe={stripePromise}>
                <NavigationContainer />
              </Elements>
            </ConfirmMessageProvider>
          </ToastProvider>
        </AuthProvider>
      </BrowserRouter>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}

export default App
